// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"513":"f8134dec3db81d83","921":"dbacbe8fc8b4ba2d"}[chunkId] + ".css";
};